/**
 * Shared display strings for content type (chips, autocomplete, queues).
 * @module gui/utils/content-type-label
 */
import { CONTENT_TYPE_TAG } from 'services/content/content-types'

export function formatContentTypeLabel (item: {
  contentType: string
  bundle?: string | null
}): string {
  if (item.contentType === CONTENT_TYPE_TAG && item.bundle) {
    return `${item.contentType} : ${item.bundle}`
  }
  return item.contentType
}
